import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "17",
  viewBox: "0 0 20 17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M5.04297 8.62305H18.4137\" stroke=\"#231F20\" stroke-width=\"1.75\" stroke-linecap=\"square\"></path><path d=\"M5.04297 1.82031H18.4137\" stroke=\"#231F20\" stroke-width=\"1.75\" stroke-linecap=\"square\"></path><rect y=\"7.80273\" width=\"1.64202\" height=\"1.64202\" fill=\"#231F20\"></rect><rect y=\"1\" width=\"1.64202\" height=\"1.64202\" fill=\"#231F20\"></rect><path d=\"M5.04297 15.8965H18.4137\" stroke=\"#231F20\" stroke-width=\"1.75\" stroke-linecap=\"square\"></path><rect y=\"15.0742\" width=\"1.64202\" height=\"1.64202\" fill=\"#231F20\"></rect>", 6)
  ])))
}
export default { render: render }